var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroBanner'),_c('IntroNotices'),_c('HomePortalSection'),_c('FooterNavStrip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }